import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function Gifts() {
    return (
        <div className="container mt-5">
            <div className="sectionContent text-start">
                <div className="row mb-4">
                    <div className="col-md-12">
                        <h1>Gifts</h1>
                    </div>
                </div>
                <p>We look forward to enjoying your company on our special day.</p>
                <p>
                    If you would like to give a gift, we would appreciate money or vouchers
                    as a contribution to our future.
                </p>
                <p>
                    There will be a postbox for cards at the wedding venue but if you prefer
                    to send a card by post, please find our address in the
                    <a href="#contact"> ‘Contact Details’</a> section.
                </p>
            </div>
        </div>
    );
}

export default Gifts;